module.exports = __webpack_public_path__ + "img/40-min.a0c17dac.jpg";